import React from 'react';

// MSAL popup redirect target. Must render and stay put — the opener window
// polls this popup's URL, reads the auth fragment off it, and closes it.
// Any navigation/redirect here would strip the fragment and break login.
const EntraAuthRedirect = () => <div style={{ padding: 24 }}>Completing sign-in…</div>;

export default EntraAuthRedirect;
